module.exports = __webpack_public_path__ + "img/IW.6381f4a7.png";